import {Component, Input} from '@angular/core';
import {BluechatLoadStatus} from '../../shared/bluechat-load.model';

@Component({
  selector: 'app-bluechat-load-status',
  templateUrl: './bluechat-load-status.component.html',
  styleUrls: ['./bluechat-load-status.component.scss']
})
export class BluechatLoadStatusComponent {

  @Input() public status: BluechatLoadStatus;

  public BLUECHAT_LOAD_STATUS = BluechatLoadStatus;
}
